import { render, staticRenderFns } from "./MaterialApp.vue?vue&type=template&id=607be236&scoped=true"
import script from "./MaterialApp.vue?vue&type=script&lang=js"
export * from "./MaterialApp.vue?vue&type=script&lang=js"
import style0 from "./MaterialApp.vue?vue&type=style&index=0&id=607be236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607be236",
  null
  
)

export default component.exports